import BigNumber from 'bignumber.js';
import { subSeconds } from 'date-fns';
import { Address, PublicClient } from 'viem';

import { LIQUID_STAKING_TOKEN_ADDRESS } from 'modules/api/const';
import { getLiquidStakingTokenContract } from 'modules/api/contracts/getLiquidStakingTokenContract';
import { convertBlocksToSeconds, convertFromWei } from 'modules/api/utils';
import { IPoolUnstake } from 'modules/pool/types';

interface IGetPendingUnstakes {
  accountAddress: Address;
  poolAddress?: Address;
}

export async function getPendingUnstakes(
  client: PublicClient,
  {
    accountAddress,
    poolAddress = LIQUID_STAKING_TOKEN_ADDRESS,
  }: IGetPendingUnstakes,
): Promise<IPoolUnstake[]> {
  const currentBlock = await client.getBlockNumber();
  const now = new Date().getTime();

  const contract = getLiquidStakingTokenContract(client, poolAddress);

  const pendingUnstakes = await contract.read.getPendingUnstakes([
    accountAddress,
  ]);

  const results = await Promise.allSettled(
    pendingUnstakes.map(({ matAtRequest, requestBlock }) => {
      const unstakeBlock = Number(requestBlock);

      const blockDifference = new BigNumber(
        Number(currentBlock) - unstakeBlock,
      );

      const now = new Date();
      const executedAt = subSeconds(
        now,
        convertBlocksToSeconds(blockDifference.toNumber()),
      );

      return {
        id: `${requestBlock}-${matAtRequest.toString()}`,
        poolAddress,
        executedAt,
        amount: convertFromWei(matAtRequest),
      };
    }),
  );

  return results
    .map(result => (result.status === 'fulfilled' ? result.value : null))
    .filter((unstake): unstake is IPoolUnstake => !!unstake)
    .sort((a, b) => {
      const timeB = new Date(b.executedAt).getTime();
      const timeA = new Date(a.executedAt).getTime();

      return Math.abs(timeB - now) - Math.abs(timeA - now);
    });
}
